import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button, Stack } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import DataTableLayout from "layouts/DatatableLayout";
import moment from "moment";
import { NumberFormat } from "utils/HelperFunction";
import { getPresentInfo } from "../../redux/handlers/logic/getPresentationInfo.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import EditIcon from "@mui/icons-material/Edit";
export function PresentView() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var param = useParams();
    var pageId = React.useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var getPresentInfoReducer = useAppSelector(function(state) {
        return state.getPresentInfoReducer;
    });
    useEffect(function() {
        dispatch(getPresentInfo(parseInt(pageId), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    var schema = yup.object().shape({
        name: yup.string().required()
    });
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.code;
            },
            center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/product/productnormal/edit/" + row.product_id + "/view",
                        children: row.code ? row.code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "บาร์โค้ด",
            selector: function(row) {
                return row.barcode;
            },
            center: "true",
            width: "150px"
        },
        {
            name: "ชื่อสินค้า",
            // center: "true",
            // width: "250px",
            selector: function(row) {
                return row.name;
            }
        },
        {
            name: "หน่วย",
            // center: "true",
            width: "120px",
            selector: function(row) {
                return row.unit;
            }
        },
        {
            name: "ราคานำเสนอ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return NumberFormat(row.pricePresent ? row.pricePresent : 0, 2);
            }
        },
        {
            name: "ราคาขาย",
            center: "true",
            width: "120px",
            selector: function(row) {
                return NumberFormat(row.priceRecommended ? row.priceRecommended : 0, 2);
            }
        },
        {
            name: "GP",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.gp;
            },
            cell: function(row, index, column, id) {
                return row.gp + " %";
            }
        },
        {
            name: "สถานะ",
            center: "true",
            width: "170px",
            selector: function(row) {
                return row.status;
            },
            cell: function(row, index, column, id) {
                return row.status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติ"
                }) || row.status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอแก้ไข"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.product_id;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.status == 5 ? /*#__PURE__*/ _jsx(Link, {
                        to: "/product/productnormal/edit/" + row.product_id,
                        style: {
                            marginRight: 3
                        },
                        children: /*#__PURE__*/ _jsx(EditIcon, {
                            style: {
                                color: "#797A7A",
                                fontSize: 30,
                                borderRadius: 40,
                                background: "#E9E9E9",
                                padding: 5
                            }
                        })
                    }) : "-"
                });
            }
        }
    ];
    var defaultData = {
        code: "-",
        dateCreate: moment().format("DD/MM/YYYY"),
        name: "",
        number: 0,
        remark: ""
    };
    var _useState1 = _sliced_to_array(useState(defaultData), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState("นำเสนอ"), 2), headerName = _useState2[0], setheaderName = _useState2[1];
    var _useState3 = _sliced_to_array(useState(true), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    // GET DATA PRESENTATION
    useEffect(function() {
        if (pageId) {
            setIsLoading(getPresentInfoReducer.isFetching);
            if (getPresentInfoReducer.data) {
                var newRow = getPresentInfoReducer.data.data.PdPpresendetail.map(function(item) {
                    return {
                        id: item.pd_ppresendetail_id,
                        code: item.PdProduct.pd_product_code,
                        barcode: item.PdProduct.pd_product_barcode,
                        name: item.PdProduct.pd_product_nameth,
                        option: item.pd_ppresentation_option,
                        unit: item.PdProduct.SetUnit ? item.PdProduct.SetUnit.set_unit_name : "-",
                        rate: item.pd_ppresentation_rate,
                        pricePresent: item.PdProduct.pd_product_price,
                        priceRecommended: item.PdProduct.pd_product_recommentprice,
                        gp: item.PdProduct.pd_product_gp,
                        status: item.PdProduct.pd_product_status,
                        product_id: item.PdProduct.pd_product_id
                    };
                });
                setProductRow(newRow);
                setFormdata({
                    code: getPresentInfoReducer.data.data.pd_ppresentation_code,
                    name: getPresentInfoReducer.data.data.pd_ppresentation_name,
                    // number: newRow.length,
                    dateCreate: getPresentInfoReducer.data.data.pd_ppresentation_credate ? new moment(getPresentInfoReducer.data.data.pd_ppresentation_credate).format("DD/MM/YYYY") : "",
                    remark: getPresentInfoReducer.data.data.pd_ppresentation_remark,
                    pd_ppresentation_status: getPresentInfoReducer.data.data.pd_ppresentation_status
                });
            }
        }
    }, [
        getPresentInfoReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "สินค้าของฉัน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "นำเสนอสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: headerName
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                validationSchema: schema,
                initialValues: formdata,
                validateOnMount: true,
                onSubmit: function(values) {},
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            paddingBottom: "100px"
                        },
                        children: /*#__PURE__*/ _jsxs(Form, {
                            noValidate: true,
                            onSubmit: function(e) {
                                e.preventDefault();
                                handleSubmit();
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("fieldset", {
                                    disabled: formdisabled,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-3 mb-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body px-xl-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Row, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 10,
                                                                xl: 10,
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "tc-8  fs-18 fw-bold px-3",
                                                                    children: "ข้อมูลสินค้า"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                md: 12,
                                                                lg: 2,
                                                                xl: 2,
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "d-flex justify-content-end",
                                                                    children: formdata.pd_ppresentation_status == 1 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "px-2 py-1 text-center",
                                                                        style: {
                                                                            color: "#6D788D)",
                                                                            backgroundColor: "rgba(244, 244, 244, 1)",
                                                                            borderRadius: "20px",
                                                                            width: "150px"
                                                                        },
                                                                        children: "แบบร่าง"
                                                                    }) || formdata.pd_ppresentation_status == 2 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "px-2 py-1 text-center",
                                                                        style: {
                                                                            color: "#FDB428",
                                                                            backgroundColor: "#FFF6E5",
                                                                            borderRadius: "20px",
                                                                            width: "150px"
                                                                        },
                                                                        children: "รอตรวจสอบ"
                                                                    }) || formdata.pd_ppresentation_status == 3 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "px-2 py-1 text-center",
                                                                        style: {
                                                                            color: "#FFFFFF",
                                                                            backgroundColor: "#10B02A",
                                                                            borderRadius: "20px",
                                                                            width: "150px"
                                                                        },
                                                                        children: "ตรวจสอบแล้ว"
                                                                    }) || formdata.pd_ppresentation_status == 4 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "px-2 py-1 text-center",
                                                                        style: {
                                                                            color: "#F95057",
                                                                            backgroundColor: "#FFE3E3",
                                                                            borderRadius: "20px",
                                                                            width: "150px"
                                                                        },
                                                                        children: "ยกเลิก"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "pt-3 px-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "รหัสลิสต์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "code",
                                                                                className: "form-control",
                                                                                placeholder: "รหัสลิสต์",
                                                                                value: values.code,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        code: e.target.value
                                                                                    }));
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "ชื่อลิสต์",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-danger ms-1",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "name",
                                                                                className: "form-control",
                                                                                placeholder: "ชื่อลิสต์",
                                                                                value: values.name,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        name: e.target.value
                                                                                    }));
                                                                                },
                                                                                isInvalid: !!errors.name
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จำนวนรายการ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "number",
                                                                                className: "form-control",
                                                                                placeholder: "จำนวนรายการ",
                                                                                value: productRow === null || productRow === void 0 ? void 0 : productRow.length,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        number: e.target.value
                                                                                    }));
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "วันที่สร้าง"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "dateCreate",
                                                                                className: "form-control",
                                                                                placeholder: moment().format("DD/MM/YYYY"),
                                                                                value: values.dateCreate,
                                                                                onChange: handleChange,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หมายเหตุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "remark",
                                                                                className: "form-control",
                                                                                placeholder: "หมายเหตุ",
                                                                                value: values.remark,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        remark: e.target.value
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-24 mb-4",
                                            children: "รายการสินค้าส่งนำเสนอ"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body px-xl-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4 mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-8 col-md-6"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-6",
                                                                children: /*#__PURE__*/ _jsx(Stack, {
                                                                    direction: "horizontal"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(DataTableLayout, {
                                                        item: productRow,
                                                        columns: columns,
                                                        isSelectRows: false,
                                                        PerPage: 10
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3 d-flex",
                                        style: {
                                            justifyContent: "flex-end",
                                            alignItems: "flex-end"
                                        },
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-6 me-3 btn",
                                            onClick: function(e) {
                                                navigate("/product");
                                            },
                                            children: "ยกเลิก"
                                        })
                                    })
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
}
